import { apiClient } from "./api";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { APP_VERSION } from "../utils/constants";

export interface AppVersionResponse {
  platform: string;
  minVersion: string;
  latestVersion: string;
  forceUpdate: boolean;
  updateAvailable: boolean;
  forceUpdateMessage: string;
  optionalUpdateMessage?: string;
  storeUrl: string;
}

export const VersionService = {
  /**
   * Checks the app version against the backend configuration.
   * @returns AppVersionResponse or null if on web/error
   */
  checkAppVersion: async (): Promise<AppVersionResponse | null> => {
    try {
      const platform = Capacitor.getPlatform();

      // Only check for mobile platforms
      if (platform !== "ios" && platform !== "android") {
        console.log(
          "Skipping version check: Platform is web or unknown:",
          platform,
        );
        return null;
      }

      const currentVersion = APP_VERSION; // e.g. "1.0.2" from constants

      console.log(`Checking app version: ${currentVersion} on ${platform}`);

      const response = await apiClient.get<AppVersionResponse>(
        "/api/app-version",
        {
          params: {
            platform,
            currentVersion,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Error checking app version:", error);
      return null;
    }
  },

  /**
   * Opens the store URL.
   * @param url Store URL
   */
  openStore: async (url: string) => {
    if (!url || typeof url !== "string") {
      console.error("VersionService.openStore called with invalid URL:", url);
      return;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
      console.error(
        "VersionService.openStore called with empty URL after trimming.",
      );
      return;
    }

    try {
      await Browser.open({ url: trimmedUrl });
    } catch (error) {
      console.error("Error opening store URL:", trimmedUrl, error);
    }
  },
};
